<template>
  <div class="eventos">
    <h2>
      Grandes eventos
      <img src="@/assets/icons/event-white.svg" alt="Ícone eventos" />
    </h2>

    <p>
      Isolamento de estruturas metálicas e isolamento de área para grandes
      eventos onde os expectadores não consigam visualizar os bastidores do
      evento.
    </p>

    <Carousel
      class="carousel"
      :class="{ fullscreen: isFullscreen }"
      v-slot="{ currentSlide }"
      htmlClass="slide-eventos"
    >
      <!-- Botão só aparece quando existe slide ativo -->
      <img
        v-if="currentSlide"
        class="fullscreen-button"
        :src="
          isFullscreen
            ? require('@/assets/icons/fullscreen-exit.svg')
            : require('@/assets/icons/fullscreen.svg')
        "
        :alt="isFullscreen ? 'Sair do fullscreen' : 'Entrar em fullscreen'"
        role="button"
        tabindex="0"
        @click.stop="toggleFullscreen"
        @keyup.enter="toggleFullscreen"
      />

      <Slide
        v-for="slide in totalSlides"
        :key="slide"
        htmlClass="slide-eventos"
        @click="toggleFullscreen"
      >
        <div v-show="currentSlide === slide" class="slide-info">
          <img :src="images[slide - 1]" :alt="`Imagem eventos ${slide}`" />
        </div>
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { ref } from "vue";
import Carousel from "@/components/Carousel/Carousel.vue";
import Slide from "@/components/Carousel/Slide.vue";

export default {
  name: "Eventos",
  components: {
    Carousel,
    Slide,
  },
  setup() {
    const totalSlides = 14;
    const isFullscreen = ref(false);

    // Pré-carrega imagens
    const images = Array.from({ length: totalSlides }, (_, i) => {
      const index = i + 1;
      try {
        return require(`@/img/eventos/${index}.jpg`);
      } catch {
        return require(`@/img/eventos/${index}.png`);
      }
    });

    const toggleFullscreen = () => {
      isFullscreen.value = !isFullscreen.value;
    };

    return {
      totalSlides,
      images,
      isFullscreen,
      toggleFullscreen,
    };
  },
};
</script>

<style lang="scss" scoped>
.eventos {
  background: var(--dark-gray);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2rem;

  h2 {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 2rem;
    font-weight: 700;
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: var(--white);
  }

  p {
    max-width: 900px;
    line-height: 150%;
    text-align: center;
    font-size: 1rem;
    font-weight: 400;
    color: var(--white);
    margin-bottom: 1.5rem;
  }
}

.carousel {
  position: relative;
  background: #000000;
  cursor: pointer;

  .fullscreen-button {
    position: absolute;
    height: 30px;
    z-index: 1;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
  }
}

.fullscreen {
  border-radius: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100vh;
  width: 100vw;
  max-width: 100%;

  .slide-info {
    height: 100vh;
  }
}

.slide-info {
  position: absolute;
  width: 100%;
  height: 600px;

  img {
    border-radius: 0.75rem;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

@media (max-width: 900px) {
  .eventos {
    padding-bottom: 0;

    p {
      margin: 0 1rem 1.5rem;
    }
  }

  .slide-info img {
    border-radius: 0;
  }
}
</style>
